module.exports = __webpack_public_path__ + "static/media/uci.bdc3c0df.svg";